import * as Sentry from '@sentry/react';

const initSentry = () => {
  Sentry.init({
    dsn:
      import.meta.env.VITE_SENTRY_DSN ??
      'https://1756c6205b254a67879235c1dbbfbe2b@o6855.ingest.sentry.io/6180938',
    release: import.meta.env.VITE_SENTRY_RELEASE ?? '',
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'development',
    integrations: [Sentry.browserTracingIntegration()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,
  });
};

export default initSentry;
